import React from 'react';
import { Link, Title } from '@gjensidige/builders-components';

import { FooterProps } from './types';

import '../less/footer.less';

type Props = {
  currentPath?: string;
  homeUrl?: string;
  nav?: FooterProps['nav'];
};

export const Nav = ({ currentPath = '', nav }: Props): JSX.Element => {
  let groups = undefined;
  if (nav.local && nav.local.length > 0) {
    nav.local.forEach((path) => {
      if (
        currentPath.startsWith(path.url) ||
        currentPath.startsWith(`/azure-ad${path.url}`)
      ) {
        groups = path.groups;
      }
    });
  }

  if (groups === undefined) {
    groups = nav.global ?? [];
  }

  return groups && groups.length > 0
    ? groups.map((item, index) => (
        <nav
          className="builders_global_nav"
          data-footer-nav={index}
          key={`${index}_${item.title}`}
        >
          <Title size="5" as="h2" className="builders_global_title">
            {item.title}
          </Title>
          {Boolean(item?.links?.length) &&
            item.links?.map((link, index) => (
              <Link
                key={`${index}_${link.text}`}
                href={link.url}
                target={link.newWindow ? '_blank' : undefined}
              >
                {link.text}
              </Link>
            ))}
        </nav>
      ))
    : null;
};
